import {
  createContext,
  useContext,
  useMemo,
  type FC,
  type ReactNode,
} from "react";

interface SignalEditorStateContextValue {
  currentDescription: string;
}

const SignalEditorStateContext =
  createContext<SignalEditorStateContextValue | null>(null);

interface SignalEditorStateProviderProps {
  currentDescription: string;
  children: ReactNode;
}

// Allow signalOperationCard to access top level description
export const SignalEditorStateProvider: FC<SignalEditorStateProviderProps> = ({
  currentDescription,
  children,
}) => {
  const value = useMemo(() => ({ currentDescription }), [currentDescription]);

  return (
    <SignalEditorStateContext.Provider value={value}>
      {children}
    </SignalEditorStateContext.Provider>
  );
};

export function useSignalEditorState(): SignalEditorStateContextValue {
  const value = useContext(SignalEditorStateContext);
  if (!value) {
    throw new Error(
      "useSignalEditorState must be used within SignalEditorStateProvider",
    );
  }
  return value;
}
